import DelayedDotLoader from "../../../../common/core-ui/DelayedDotLoader.tsx";
import DefaultError from "../../../../common/core-ui/DefaultError.tsx";
import { clsx } from "clsx";
import { FormattedMessage } from "react-intl";
import styles from "./PaginatedAssetFetcherStatus.module.scss";
import { ReactNode } from "react";
import usePaginatedAssetFetcherStatus from "./usePaginatedAssetFetcherStatus.ts";
import { Fetcher } from "react-router-dom";

export default function PaginatedAssetFetcherStatus({
  onShowMore,
  emptyState,
  fetchers,
}: {
  onShowMore?: () => void;
  emptyState: ReactNode;
  fetchers: Fetcher[];
}) {
  const { paginationStatus, loadStatus, contentLengthStatus } =
    usePaginatedAssetFetcherStatus(fetchers);

  if (loadStatus === "loading") {
    return <DelayedDotLoader />;
  }
  if (loadStatus === "error") {
    return <DefaultError />;
  }
  if (onShowMore && paginationStatus === "has-more-pages") {
    return (
      <button
        className={clsx(
          "vst-button-pill",
          "vst-button-variant-outline",
          styles.loadMore
        )}
        onClick={onShowMore}
      >
        <FormattedMessage defaultMessage="Load More" />
      </button>
    );
  }
  if (contentLengthStatus === "empty") {
    return emptyState;
  }
}
